"use strict";
/* eslint-disable no-param-reassign */
Object.defineProperty(exports, "__esModule", { value: true });
exports.registerEvents = exports.registerEvent = void 0;
/**
 * Register an event with Client Profiler. Additionally, if the event is static,
 * add its name to the eventStartQueue for the next beacon. (This tells us we
 * expect the event to be measured eventually.)
 *
 * If the event has already been registered, `eventDetails` will be replaced,
 * but the event will not be added to the start queue even if it's static. (So
 * we still only expect to measure the event once.)
 */
function registerEvent(profiler, eventName, eventDetails) {
    const { eventRegistry, eventStartQueue } = profiler;
    const isOverride = eventRegistry[eventName] !== undefined;
    const isStatic = !eventDetails.isDynamic;
    eventRegistry[eventName] = eventDetails;
    // If the event is static, add it to the start queue for the next beacon,
    // unless it's already been previously registered.
    if (isStatic && !isOverride)
        eventStartQueue.push(eventName);
}
exports.registerEvent = registerEvent;
/** Register multiple RUM events. See `registerEvent()` for details.  */
function registerEvents(profiler, events) {
    // Don't update the event registry directly, e.g., `eventRegistry = {
    // ...eventRegistry, ...events }`, b/c the registration behavior may change
    // in the future. Instead, use `registerEvent()` to ensure consistent
    // registration behavior.
    Object.keys(events).forEach((eventName) => {
        registerEvent(profiler, eventName, events[eventName]);
    });
}
exports.registerEvents = registerEvents;
